module.exports = __webpack_public_path__ + "static/img/hosoda_01.42cacd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/hosoda_01.png
// module id = cD0/
// module chunks = 0